import { Grid } from '../../../Common/Grid'
import { Button, Input } from '@fullscreendigital/carrefour-dex-fe'
import React, { useMemo, useState } from 'react'
import { getValidationSchema, initialValues } from './helpers'
import { useFormik } from 'formik'
import { formatErrorMessage } from '../../../../../utils/formatting'
import { useNotification } from '../../../../../hooks'
import { TitleHeader } from '../../Common/TitleHeader'
import { useQuery } from 'react-query'
import { makeCoreGetRequest, makeCorePostRequest } from '../../../../../utils/api'
import ImageUpload from '../../Common/ImageUpload/ImageUpload'
import { CircularProgress } from '@mui/material'

const PackagingInventoryUpdate = () => {
  const { showNotification } = useNotification()

  const validationSchema = useMemo(() => getValidationSchema(), [])
  const formik = useFormik({
    enableReinitialize: false,
    validateOnChange: false,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values: any) => {
      try {
        await makeCorePostRequest('/shop-reception-mobile/support/shop/inventory/save', values)

        showNotification({
          message: `Inventar actualizat cu succes.`,
          type: 'success'
        })
        clearFields()
      } catch (error) {
        showNotification({
          message: `Error while submitting. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  })

  function clearFields() {
    setSelectedSupportId('')
    formik.setFieldValue('supportId', null)
    formik.setFieldValue('conform', '')
    formik.setFieldValue('defect', '')
  }

  const [selectedSupportId, setSelectedSupportId] = useState(formik.values.supportId || '')

  const { data: supportList, isLoading } = useQuery(
    'supportList',
    async () => {
      return await makeCoreGetRequest('/shop-reception-mobile/support/shop/all', null)
    },
    {
      onError: error => {
        showNotification({
          message: `Error while fetching supports. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  const { data: shopCode, isLoading: isLoadingShopCode } = useQuery(
    'shopCode',
    async () => {
      const shopCode = await makeCoreGetRequest('/shop-reception-mobile/home/shop-code', null)
      await formik.setFieldValue('shopId', Number(shopCode.value))

      return shopCode.value
    },
    {
      onError: error => {
        showNotification({
          message: `Error while fetching supports. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  if (isLoading || isLoadingShopCode) {
    return <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
  }

  const handleSuccess = data => {
    formik.setFieldValue('defectPictureId', data.id)

    showNotification({
      message: 'Imaginea a fost încărcată cu succes.',
      type: 'success'
    })
  }

  const handleError = error => {
    showNotification({
      message: `Error uploading image: ${error.message}`,
      type: 'error'
    })
  }

  return (
    <Grid
      gridContainerStyle={{ marginTop: '20px' }}
      maxWidth="xs"
      items={[
        <TitleHeader title="ACTUALIZARE INVENTAR AMBALAJE" />,
        <Input
          type="select"
          label="Tip suport"
          variant="standard"
          width="100%"
          value={selectedSupportId}
          values={supportList?.map(support => ({ value: support.id, label: support.name }))}
          onChange={event => {
            const selectedValue = (event.target as HTMLInputElement).value
            setSelectedSupportId(selectedValue)
            formik.setFieldValue('supportId', selectedValue)
          }}
          error={!!formik.errors.supportId}
          helperText={formik.errors.supportId as string}
        />,
        <Input
          type="number"
          label="Calitativi"
          variant="standard"
          width="100%"
          value={formik.values.conform}
          onChange={event =>
            formik.setFieldValue('conform', +(event.target as HTMLInputElement).value)
          }
          error={!!formik.errors.conform}
          helperText={formik.errors.conform as string}
        />,
        <div>
          <Input
            type="number"
            label="Defecți"
            variant="standard"
            width="100%"
            value={formik.values.defect}
            onChange={event =>
              formik.setFieldValue('defect', +(event.target as HTMLInputElement).value)
            }
            error={!!formik.errors.defect}
            helperText={formik.errors.defect as string}
          />
          {formik.values.defect > 0 && +selectedSupportId > 0 && (
            <ImageUpload
              uploadUrl={'/shop-reception-mobile/support/shop/upload/' + selectedSupportId}
              onSuccess={handleSuccess}
              onError={handleError}
            />
          )}
        </div>,
        <Button
          type="button"
          variant="contained"
          label="CONFIRMǍ"
          style={{ width: '100%' }}
          onClick={() => formik.handleSubmit()}
          disabled={formik.isSubmitting}
        />
      ]}
      itemsPerRow={1}
    />
  )
}

export default PackagingInventoryUpdate
